import type { WorkAssignment } from "../types/work-assignment.types";

/** Assignee id for links, permissions, and labels (`user` embed may carry the same id). */
export function workAssignmentAssigneeId(a: WorkAssignment): number {
  return Number(a.toUserId);
}

/**
 * Normalizes API rows that may still send legacy `userId` / snake_case until the
 * backend migration is complete.
 */
export function normalizeWorkAssignment(row: unknown): WorkAssignment {
  const r = row as Record<string, any>;
  const toUserId = Number(
    r.toUserId ?? r.to_user_id ?? r.userId ?? r.user_id ?? 0,
  );
  const fromRaw = r.fromUserId ?? r.from_user_id;
  const fromUserId =
    fromRaw != null &&
    fromRaw !== "" &&
    Number.isFinite(Number(fromRaw)) &&
    Number(fromRaw) > 0
      ? Number(fromRaw)
      : null;
  const isActiveRaw = r.isActive ?? r.is_active;
  const isActive =
    typeof isActiveRaw === "boolean" ? isActiveRaw : undefined;

  return {
    ...r,
    toUserId: Number.isFinite(toUserId) && toUserId > 0 ? toUserId : 0,
    fromUserId,
    isActive,
  } as WorkAssignment;
}
